// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * Human-readable text with an optional locale.
 */
export class LocalizedText implements flatbuffers.IUnpackableObject<LocalizedTextT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): LocalizedText {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsLocalizedText(bb: flatbuffers.ByteBuffer, obj?: LocalizedText): LocalizedText {
    return (obj || new LocalizedText()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsLocalizedText(
    bb: flatbuffers.ByteBuffer,
    obj?: LocalizedText,
  ): LocalizedText {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new LocalizedText()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  locale(): string | null;
  locale(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  locale(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  text(): string;
  text(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  text(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  static startLocalizedText(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addLocale(builder: flatbuffers.Builder, localeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, localeOffset, 0);
  }

  static addText(builder: flatbuffers.Builder, textOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, textOffset, 0);
  }

  static endLocalizedText(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // text
    return offset;
  }

  static createLocalizedText(
    builder: flatbuffers.Builder,
    localeOffset: flatbuffers.Offset,
    textOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    LocalizedText.startLocalizedText(builder);
    LocalizedText.addLocale(builder, localeOffset);
    LocalizedText.addText(builder, textOffset);
    return LocalizedText.endLocalizedText(builder);
  }

  unpack(): LocalizedTextT {
    return new LocalizedTextT(this.locale(), this.text());
  }

  unpackTo(_o: LocalizedTextT): void {
    _o.locale = this.locale();
    _o.text = this.text();
  }

  unpackFields(...fields: string[]): LocalizedTextT {
    const t = new LocalizedTextT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("locale")) {
      t.locale = this.locale();
    }
    if (fieldSet.has("text")) {
      t.text = this.text();
    }
    return t;
  }
}

export class LocalizedTextT implements flatbuffers.IGeneratedObject {
  constructor(
    public locale: string | Uint8Array | null = null,
    public text: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.text === null || this.text === undefined) {
      throw new Error('Required field "text" is not set');
    }
    const locale = this.locale !== null ? builder.createString(this.locale!) : 0;
    const text = this.text !== null ? builder.createString(this.text!) : 0;

    return LocalizedText.createLocalizedText(builder, locale, text);
  }

  clone(): LocalizedTextT {
    const obj = new LocalizedTextT();
    obj.locale = this.locale;
    obj.text = this.text;
    return obj;
  }

  equals(other: LocalizedTextT): boolean {
    if (this.locale !== other.locale) return false;
    if (this.text !== other.text) return false;
    return true;
  }
}

export function verifyLocalizedText(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "text");
  } finally {
    verifier.popDepth();
  }
}
